import GlossaryContent from "../../components/others/glossaryScreen/GlossaryContent";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";
import SystemAppContentLayout from "../../components/layouts/SystemAppContentLayout";
import GlossaryLayout from "../../components/layouts/glossaryScreen/GlossaryLayout";

export default function GlossaryScreen() {
    // Used in index.js by the router as an entry point
    // for compulsory legal texts, in tablet and desktop modes

    // BUILD
    return (
        <div className={"w-full h-[100svh] flex justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Glossaire')}</title>
                <meta name="description"
                      content="Liste des termes mathématiques à connaître au collège." />
            </Helmet>
            {/** CONTENT */}
            <GlossaryLayout>
                <SystemAppContentLayout>
                    <GlossaryContent />
                </SystemAppContentLayout>
            </GlossaryLayout>
        </div>
    );
}